import { useEffect, useRef, useState } from "react";
import { ChevronUp } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

// Styleguide Kap. 11 „Scrollen“: oben läuft eine orange Fortschrittslinie mit,
// nach einer Bildschirmhöhe erscheint unten rechts „Nach oben“.
const ScrollChrome = () => {
    const { lang } = useLanguage();
    const bar = useRef(null);
    const [top, setTop] = useState(false);
    useEffect(() => {
        let raf = 0;
        const onScroll = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                const y = window.scrollY;
                const max = document.documentElement.scrollHeight - window.innerHeight;
                if (bar.current) bar.current.style.setProperty("--progress", max > 0 ? Math.min(1, y / max) : 0);
                setTop(y > window.innerHeight);
            });
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        onScroll();
        return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); cancelAnimationFrame(raf); };
    }, []);
    const toTop = () => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    };
    return (
        <>
            <div ref={bar} className="scroll-progress" aria-hidden="true" />
            <button type="button" onClick={toTop} className={`to-top ${top ? "is-visible" : ""}`} aria-label={lang === "en" ? "Back to top" : "Nach oben"} tabIndex={top ? 0 : -1}>
                <ChevronUp size={20} strokeWidth={1.6} />
            </button>
        </>
    );
};

export default ScrollChrome;
